import { Component, EventEmitter, Input, OnInit, Output, NgModule, Inject, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router, ActivatedRoute } from '@angular/router';
import { CASINO_LOBBY_GAMES } from '@environments/environment';
import { environment } from '@environments/environment';

@Component({
  selector: 'casinogroupgalobby-component',
  templateUrl: '../sharedTemplates/casinogroupgalobby-component.html',
})
export class CasinoGroupGALobbyComponent implements AfterViewInit {
  casinoList = [];

  selectedCasinoType = 0;

  gameTypes;
  provider;
  doubleClickFlag = false;
  constructor(
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      this.provider = params['provider'];
    });
  }

  getCasinoGames() {
    this._ApiService.getCasinoGroupGA().then(x => {
      this.gameTypes = x.filter(s => s.ProviderId.toString() === this.provider.toString());
    });
  }

  goGames(item) {
    this.doubleClickFlag = !this.doubleClickFlag;
    if (!this._UserHelper.isSignedIn) {
      const translator = new TranslatePipe(this._LocalizationService);
      const t_message = translator.transform('errorcode5', null);
      this._UiHelper.errorSnackBar(t_message, '');
      return;
    }

    let platform;
    if (environment.mobile) {
      platform = 'mobile';
    } else {
      platform = 'desktop';
    }
    if (this.doubleClickFlag) {
      this._ApiService.CasinoGroupGALaunch(item.GameId, platform).then(x => {
        window.location.href = x.url;
      });
    }
  }

  ngAfterViewInit() {
    if (this._UiHelper.leftMenu) this._UiHelper.setLeftMenu();

    this._UiHelper.setNavbarTitle('Casino', true);
    this.getCasinoGames();
  }
}
